export default __webpack_public_path__ + "static/media/Arthur.8aa153bd.webp";